/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TreatmentStatusUpdate/view.blocks to change it.
import Content from './Content/index'
import Empty from './Empty/index'
import Error from './Error/index'
import Loading from './Loading/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function TreatmentStatusUpdate({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Automations/Content/Content/SetupAction/Content/Content/Content/Steps/Content/ActiveStep/Automation/Event/TreatmentStatusUpdate"
  
}) {
  return (<React.Fragment
>
<No
  viewPath={`${viewPath}/No`}
/>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
<Content
  viewPath={`${viewPath}/Content`}
/>
<Empty
  viewPath={`${viewPath}/Empty`}
/>
<Error
  viewPath={`${viewPath}/Error`}
/>
{children}
</React.Fragment>)
}